module.exports = __webpack_public_path__ + "img/whatsapp.50d77d35.svg";